<ng-container *ngIf="dialog$ | async as dialog">
    <div class="modal-header modal-header--import flex-column">
        <div class="modal-title">Import - Tables</div>
        <div class="modal-subtitle mt-2">Import tables from an excel file (Download 
            <a [href]="sampleFile" class="template">template</a>) 
            <a class="template" (click)="onToggleReadMore()">{{readmore ? 'hide more': 'read more'}}</a>
        </div>
        <button type="button" class="cursor-pointer" class="close close--paybee position-absolute" data-dismiss="modal" aria-label="Close" (click)="close(dialog, false)">
            <span class="cursor-pointer" aria-hidden="true">×</span>
        </button>
        <div class="readmore mt-2" *ngIf="readmore">
            <div class="mb-3">Support File Format: Excel with header row</div>
            <div>
                <div class="headline-7--temporary mb-2">Tables Sheet</div>
                <div class="modal-subtitle mb-2">Fill for all tables</div>
                <table width="750" border="2" cellpadding="5">
                    <thead>
                        <tr>
                            <td><b>Column Name</b></td>
                            <td><b>Required</b></td>
                            <td><b>Description</b></td>
                            <td><b>Note</b></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Table Number</td>
                            <td>required</td>
                            <td>Table Number</td>
                            <td>Min value 1</td>
                        </tr>
                        <tr>
                            <td>Table Name</td>
                            <td>optional</td>
                            <td>Table Name</td>
                            <td>Full Table Name (16 characters max)</td>
                        </tr>
                        <tr>
                            <td>Category</td>
                            <td>optional</td>
                            <td>Table Category</td>
                            <td>Full Table Category (16 characters max)</td>
                        </tr>
                        <tr>
                            <td>Number of Seats</td>
                            <td>required</td>
                            <td>Number of Seats</td>
                            <td>Min value 1</td>
                        </tr>
                        <tr>
                            <td>Guests will have assigned seats</td>
                            <td>optional</td>
                            <td>Guests will have assigned seats</td>
                            <td>Enable Assigned Seating (yes or no). By Default 'no' </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div>
                <div class="headline-7--temporary mb-2 mt-3">Seats Sheet</div>
                <div class="modal-subtitle mb-2">Fill if specific seat assignment for any table is required</div>
                <table width="750" border="2" cellpadding="5">
                    <thead>
                        <tr>
                            <td><b>Column Name</b></td>
                            <td><b>Required</b></td>
                            <td><b>Description</b></td>
                            <td><b>Note</b></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Table Number</td>
                            <td>optional</td>
                            <td>Table Number</td>
                            <td>Min value 1</td>
                        </tr>
                        <tr>
                            <td>Seat Number</td>
                            <td>optional</td>
                            <td>Number of Seat</td>
                            <td>Min value 1</td>
                        </tr>
                        <tr>
                            <td>Seat Name</td>
                            <td>optional</td>
                            <td>Seat Name</td>
                            <td>Full Name of Seat (16 characters max)</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="modal-body" *ngIf="!closeButton">
        <div class="d-none" style="border-color: #e6e6e6!important; height: 250px !important;"> </div>
        <div class="d-none" style="color: #000!important; height: 250px !important;"> </div>
        <app-tables-import-xlsx
            [schema]="schema"
            [import]="import"
            [tables]="tables"
            [seats]="seats"
            (onChange)="onChangeData($event)"
        ></app-tables-import-xlsx>
    </div>
    <div class="modal-body" *ngIf="closeButton">
        <div *ngIf="closeButton" class="d-flex flex-column align-items-center my-5">
            <div>Successfully loaded {{tables.length}} items.</div>
            <div>New items will appear at the bottom.</div>
        </div>
    </div>
    <div class="modal-footer modal-footer--import">
        <div class="d-flex justify-content-between w-100">
            <div class="col-8 d-flex align-items-center">
                <ng-container *ngIf="import.value">
                    <div *ngIf="tables.length == 1" class="modal__found">{{tables.length}} item found</div>
                    <div *ngIf="tables.length > 1" class="modal__found">{{tables.length}} items found</div>
                </ng-container>
            </div>
            <div class="col-4">
                <div class="row">
                    <div class="col-6 px-2">
                        <button
                            *ngIf="confirm"
                            type="button"
                            class="btn btn--paybee btn--black btn--md text-center w-100"
                            (click)="onConfirm(dialog)"
                            [disabled]="confirmDisabled"
                        >Confirm</button>
                        <button
                            *ngIf="closeButton"
                            type="button"
                            class="btn btn--paybee btn--black btn--md text-center w-100"
                            (click)="onClose(dialog)"
                        >Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </ng-container>
